export const actions = {
  consumeSku (context, { id, type, confirmed }) {
    return this.$axios.post('v1/entitlements/consume', { confirmed, sku: { id, type } })
  },
  async consumeEntitlement (context, { id, type, confirmed, language }) {
    try {
      const axiosConfig = language ? { headers: { 'x-app-locale': language } } : {}
      const result = await this.$axios.post('v1/entitlements/consume', { confirmed, sku: { id, type } }, axiosConfig)

      if (result && result.data && result.data.sku) {
        return result
      }
    } catch (error) {
      if (error && error.response) {
        // unauthorized - redirect the user to login
        if (error.response.status === 401) {
          const url = new URL(window.location.href)
          url.searchParams.set('openOverlay', id)
          window.open(`/dashboard/?continue=${url}`)

          return false
          // eslint-disable-next-line brace-style
        }
        // payment required
        else if ([402, 409].includes(error.response.status)) {
          return Promise.reject(new Error('409'))
        }
      }

      return null
    }
  }
}
